// extracted by mini-css-extract-plugin
export default {"dropZoneArea":"DropZone_dropZoneArea__DPWD5","isDragActive":"DropZone_isDragActive__CCWk8","Drag_icn":"DropZone_Drag_icn__RpVJ-"};